import type {Result, UseCase} from 'framework';
import type {WeightTrackingError} from '../../domain/errors';
import type {WeightEntry} from '../../domain/weight-entry';
import type {WeightTrackingRepository} from '../ports/weight-tracking.repository';

export type RecordWeightInput = {
  readonly weightKg: number;
};

export class RecordWeight implements UseCase<[RecordWeightInput], WeightEntry> {
  constructor(private readonly repository: WeightTrackingRepository) {}

  execute(input: RecordWeightInput): Promise<Result<WeightEntry, WeightTrackingError>> {
    return this.repository.record(input.weightKg);
  }
}
